import { POST } from '~/consts';

export default {
  data() {
    return {
      counterDoc: 0,
      counterDocInterval: null,
      counterVideo: 0,
      counterVideoInterval: null,
      loading_like: false,
      loading_get_description: false
    }
  },

  methods: {
    onGetPostSingleSuccess() {},
    onGetPostSingleFailed() {},
    getPostSingle(id) {
      const vm = this
      this.$axios.post(POST.GET_DETAIL(id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetPostSingleSuccess(data)
          } else {
            vm.onGetPostSingleFailed(data)
          }
        })
        .catch(() => {

        })
    },

    deletePost(id) {
      const vm = this;

      this.$buefy.dialog.confirm({
        message: 'Apakah anda yakin untuk menghapus postingan ini?',
        confirmText: 'Ya',
        cancelText: 'Batal',
        type: 'is-danger',
        onConfirm: () => {
          this.$axios.post(POST.DESTROY(id))
            .then(({ data }) => {
              if (data.applicationSystem.code == 0) {
                this.track('post', 'delete_post', id)
                vm.onDeletedPost(data, id);
              } else {
                vm.onFailDeletePost(data, id);
              }
            }).catch(() => {

            })
        }
      })
    },
    onDeletedPost() {

    },
    onRecoverPostSuccess() {},
    onRecoverPostFailed() {},
    recoverPost(id) {
      const vm = this;

      this.$buefy.dialog.confirm({
        message: 'Apakah anda yakin akan memulihkan postingan ini?',
        confirmText: 'Ya',
        cancelText: 'Batal',
        type: 'is-danger',
        onConfirm: () => {
          this.$axios.post(POST.RECOVER(id))
            .then(({ data }) => {
              if (data.applicationSystem.code == 0) {
                this.track('post', 'recovery_post', id)
                vm.onRecoverPostSuccess(data, id);
              } else {
                vm.onRecoverPostFailed(data, id);
              }
            }).catch(() => {

            })
        }
      })
    },
    onFailDeletePost(res) {
      toast.danger(res.applicationSystem.message);
    },

    onVideoPlaying(e) {
      const vm = this

      vm.counterVideoInterval = setInterval(function () {
        vm.counterVideo = vm.counterVideo + 1;
      }, 1000)
    },
    onVideoPaused(e, duration, post_id, gm_id) {
      const vm = this

      clearInterval(vm.counterVideoInterval);
      vm.counterVideoInterval = null;

      this.track('learning_material', 'long_time_to_see_video_learning_material', post_id, 'gm', gm_id, {
        value: this.counterVideo,
        duration: Math.round(duration)
      })
    },
    onVideoBuffer() {
      const vm = this

      clearInterval(vm.counterVideoInterval);
      vm.counterVideoInterval = null;
    },
    onVideoEnded(e, duration, post_id, gm_id) {
      const vm = this

      clearInterval(vm.counterVideoInterval);
      vm.counterVideoInterval = null;

      this.track('learning_material', 'long_time_to_see_video_learning_material', post_id, 'gm', gm_id, {
        value: this.counterVideo,
        duration: Math.round(duration)
      })
      vm.counterVideo = 0
    },

    onLikeSuccess() {},
    onLikeFailed() {},
    like(id, is_unlike = false) {
      this.track('post', is_unlike ? 'unlike_post' : 'like_post', id)
      this.onLikeSuccess(!is_unlike);
    },

    onSeeMoreSuccess() {},
    onSeeMoreFailed() {},
    seeMore(id) {
      const vm = this

      vm.loading_get_description = true
      this.$axios.post(POST.GET_DESCRIPTION(id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onSeeMoreSuccess(data)
            this.track('post', 'post_clicked_see_more', id)
          } else {
            vm.onSeeMoreFailed()
          }

          vm.loading_get_description = false
        })
        .catch(({ response }) => {
          vm.onSeeMoreFailed()
          vm.loading_get_description = false
        })
    }
  }
}
